import { createSelector } from '@reduxjs/toolkit';
import { composeAccumulator } from "../../../utils";
import { selectFTTBConnectionBlockData } from "../../../store/selectors";
var selectContent = function selectContent(state) {
  var _selectFTTBConnection;
  return ((_selectFTTBConnection = selectFTTBConnectionBlockData(state)) === null || _selectFTTBConnection === void 0 ? void 0 : _selectFTTBConnection.content) || {};
};
export var selectTvImage = function selectTvImage(state) {
  var _selectContent;
  return (_selectContent = selectContent(state)) === null || _selectContent === void 0 ? void 0 : _selectContent.tvImage;
};
export var selectInternetImage = function selectInternetImage(state) {
  var _selectContent2;
  return (_selectContent2 = selectContent(state)) === null || _selectContent2 === void 0 ? void 0 : _selectContent2.internetImage;
};
export var selectFttbConnectUrl = function selectFttbConnectUrl(state) {
  var _selectContent3;
  return (_selectContent3 = selectContent(state)) === null || _selectContent3 === void 0 ? void 0 : _selectContent3.fttbConnectUrl;
};
var selectTV = function selectTV(state) {
  var _selectFTTBConnection2;
  return ((_selectFTTBConnection2 = selectFTTBConnectionBlockData(state)) === null || _selectFTTBConnection2 === void 0 ? void 0 : _selectFTTBConnection2.tv) || {};
};
var selectInternet = function selectInternet(state) {
  var _selectFTTBConnection3;
  return ((_selectFTTBConnection3 = selectFTTBConnectionBlockData(state)) === null || _selectFTTBConnection3 === void 0 ? void 0 : _selectFTTBConnection3.internet) || {};
};
var selectTariff = function selectTariff(state) {
  var _selectFTTBConnection4;
  return ((_selectFTTBConnection4 = selectFTTBConnectionBlockData(state)) === null || _selectFTTBConnection4 === void 0 ? void 0 : _selectFTTBConnection4.tariff) || {};
};
export var selectTariffName = function selectTariffName(state) {
  var _selectTariff;
  return (_selectTariff = selectTariff(state)) === null || _selectTariff === void 0 ? void 0 : _selectTariff.name;
};
var selectFee = function selectFee(state) {
  var _selectFTTBConnection5;
  return ((_selectFTTBConnection5 = selectFTTBConnectionBlockData(state)) === null || _selectFTTBConnection5 === void 0 ? void 0 : _selectFTTBConnection5.fee) || {};
};
export var selectBillingDate = function selectBillingDate(state) {
  var _selectFee;
  return (_selectFee = selectFee(state)) === null || _selectFee === void 0 ? void 0 : _selectFee.billingDate;
};
export var selectPeriodDays = function selectPeriodDays(state) {
  var _selectFee2;
  return (_selectFee2 = selectFee(state)) === null || _selectFee2 === void 0 ? void 0 : _selectFee2.period;
};
export var selectPriceValue = function selectPriceValue(state) {
  var _selectFee3;
  return (_selectFee3 = selectFee(state)) === null || _selectFee3 === void 0 ? void 0 : _selectFee3.value;
};
export var selectNextPriceValue = function selectNextPriceValue(state) {
  var _selectFee4;
  return (_selectFee4 = selectFee(state)) === null || _selectFee4 === void 0 ? void 0 : _selectFee4.nextValue;
};
export var selectTrialEndDate = function selectTrialEndDate(state) {
  var _selectFee5;
  return (_selectFee5 = selectFee(state)) === null || _selectFee5 === void 0 ? void 0 : _selectFee5.trialEndDate;
};
var selectTechnicalInfo = function selectTechnicalInfo(state) {
  var _selectFTTBConnection6;
  return ((_selectFTTBConnection6 = selectFTTBConnectionBlockData(state)) === null || _selectFTTBConnection6 === void 0 ? void 0 : _selectFTTBConnection6.technicalInfo) || {};
};
export var selectAddress = function selectAddress(state) {
  var _selectTechnicalInfo;
  return (_selectTechnicalInfo = selectTechnicalInfo(state)) === null || _selectTechnicalInfo === void 0 ? void 0 : _selectTechnicalInfo.address;
};
export var selectTitle = createSelector([selectContent, selectTV], function (_ref, tv) {
  var titleInternetNoTv = _ref.titleInternetNoTv,
    titleInternetWithTv = _ref.titleInternetWithTv;
  return !Object.keys(tv).length ? titleInternetNoTv : titleInternetWithTv;
});
export var selectFTTBAccumulators = createSelector([selectInternet, selectInternetImage, selectTV, selectTvImage], function (internet, internetImage, tv, tvImage) {
  return [composeAccumulator({
    iconSrc: internetImage,
    value: internet.speedIn,
    unit: internet.speedInUnit
  }), composeAccumulator({
    iconSrc: tvImage,
    value: tv.channelsCount,
    unit: tv.channelsCountUnit
  })].filter(function (item) {
    return !!item;
  });
});